import React from "react"

const AttentionIndicator = ({ score, size = "md", light = false }) => {
  const getLevel = () => {
    if (score >= 5) return "high"
    if (score >= 1) return "medium"
    return "good"
  }

  const level = getLevel()

  const colors = {
    high: "bg-red-500",
    medium: "bg-amber-500",
    good: "bg-emerald-500",
  }

  const lightColors = {
    high: "bg-red-400",
    medium: "bg-amber-400",
    good: "bg-emerald-400",
  }

  const textColors = {
    high: light ? "text-white/90" : "text-red-600",
    medium: light ? "text-white/90" : "text-amber-600",
    good: light ? "text-white/90" : "text-emerald-600",
  }

  const sizes = {
    sm: "w-2 h-2",
    md: "w-3 h-3",
    lg: "w-4 h-4",
  }

  const labels = {
    high: "Needs attention",
    medium: "Some items due",
    good: "All caught up",
  }

  const bgColors = light ? lightColors : colors

  return (
    <div className="flex items-center gap-2">
      <span
        className={`${bgColors[level]} ${sizes[size]} rounded-full ${level === "high" ? "pulse-urgent" : ""}`}
        title={labels[level]}
      />
      {size === "lg" && (
        <span className={`text-sm font-medium ${textColors[level]}`}>
          {labels[level]}
        </span>
      )}
    </div>
  )
}

export default AttentionIndicator
